/**
 * Añade nº de sillas infantiles.
 * @param _COMMENTS Array de comentarios
 * @param data Valor que proviene de la modal
 * @returns Array de comentarios añadido o modificado.
 */
export function addCommentsBaby(_COMMENTS: any[], data: any) {
    const seatData = { type: "CHILD_SEAT", value: data.counter+'', id: 'baby' };
    _COMMENTS.push(seatData);
    return _COMMENTS;
}
/**
 * Añade comentarios para el taxi.
 * @param _COMMENTS Array de comentarios
 * @param data Valor que proviene de la modal
 * @param detailIndexSelected PST correspondiente al taxi
 * @returns Array de comentarios añadido o modificado.
 */
export function addCommentsDriver(_COMMENTS: any[], data: any, detailIndexSelected: number) {
    const commentsData = { type: "COMMENTS", value: data.value, id: detailIndexSelected };
    const i = _COMMENTS.findIndex((note) => note.type === "COMMENTS" && note.id === detailIndexSelected);
    if (i !== -1) {
        _COMMENTS[i] = commentsData;
    } else {
        _COMMENTS.push(commentsData);
    }
    return _COMMENTS;
}
/**
 * Comentarios para cada taxista e informa nº de sillas infantiles a todos los taxistas (si hubiera).
 * @param _COMMENTS Array de comentarios
 * @param idLeg Id del pst del taxi
 * @returns Array de comentarios específico para el taxi
 */
export function addCommentsToNotes(_COMMENTS: any[], idLeg: number) {
    const comments = _COMMENTS.filter((note: any) => note.id === idLeg/*.toString()*/ || note.id == 'baby');
    return comments.map((item) => { return { type: item.type, value: item.value } })
}